import { t } from '@lingui/macro';

import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

export const EXPLANATION_MODAL_HEADER = (): string => t`How pricing works`;
export const EXPLANATION_MODAL_BUTTON_TEXT = (): string => t`Got it`;
export const URL = (): string =>
  getBrandSpecificValue({
    rover: 'https://support.rover.com/hc/en-us/articles/205385304-What-are-the-service-fees',
    catInAFlat:
      'https://catinaflat.zendesk.com/hc/en-us/articles/43808447826196-What-are-the-service-fees',
  });

export const EXPLANATION_MODAL_PARAGRAPH_WITH_LINK = (
  isPtFull: boolean,
  percentageFee: string
): string => {
  return isPtFull
    ? t`Prices shown include a <0>booking fee</0> of ${percentageFee}. The Rover booking fee is finalized at checkout based on the options and preferences you select for the booking, including dates, number of pets, types of pets, duration, and any add-ons or discounts.`
    : t`Total prices may vary based on your search and a <0>booking fee</0> of ${percentageFee} will apply. The Rover booking fee is finalized at checkout based on the options and preferences you select for the booking, including dates, number of pets, types of pets, duration, and any add-ons or discounts.`;
};
